import React from "react";
import { MdWaterDrop } from "react-icons/md";
import { HiOutlineViewGridAdd } from "react-icons/hi";
import { GiScubaTanks } from "react-icons/gi";
import { FaSyringe } from "react-icons/fa";
import style from "./Cancelled.module.scss";
import { constructOrderDate } from "../../../helper/DateFormatter";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { InfoCircleFilled } from "@ant-design/icons";

const Cancelled = ({ b_type, hospital, product, tym, qty, title, reason }) => {
  const badgeColor = () => {
    if (product === "blood") return "#FDE0E0";
    if (product === "oxygen") return "#E0EFFD";
    return "#F0FDE0";
  };

  const icons = () => {
    if (product === "blood") return <MdWaterDrop size={25} color="#B70303" />;
    if (product === "oxygen") return <GiScubaTanks size={25} color="#2457C5" />;
    return <FaSyringe size={25} color="#78A55A" />;
  };

  const colors = () => {
    if (product === "blood") return "#B70303";
    if (product === "oxygen") return "#2457C5";
    return "#78A55A";
  };

  return (
    <>
      <div>
        <div className={style.container}>
          <div className={style.innerContainer}>
            <div className={style.content}>
              <div
                className={`${style.icon}`}
                style={{ background: badgeColor() }}
              >
                {icons()}
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>Product Name</p>
                <p className={style.text}>{b_type}</p>
              </div>
            </div>

            <div className={style.content}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <HiOutlineViewGridAdd size={25} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>QUANTITY</p>
                <p className={style.text}>{qty}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>HOSPITAL NAME</p>
                <p className={style.text} style={{ width: "15vw" }}>
                  {hospital}
                </p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>TOPIC</p>
                <p className={style.text} style={{ width: "10vw" }}>
                  {title}
                </p>
              </div>
            </div>
            <div className={`${style.content} ${style.address}`}>
              <div className={style.icon} style={{ background: badgeColor() }}>
                <InfoCircleFilled
                  style={{ color: colors(), fontSize: "25px" }}
                />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>CANCEL REASON</p>
                <p className={style.text2}>{reason}</p>
              </div>
            </div>
          </div>
          <div className={style.bott}>
            <div className={style.time}>
              Time Cancelled :{constructOrderDate(tym)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cancelled;
